/**
 * Created by joellee on 12/11/15.
 */
commonModule.factory('themeService', ['imSessionVarsService',
    function (imSessionVarsService) {
        var service = {};

        // As new themes are created, they should be listed here
        var _availableThemes = {
            'default': {
              name: 'tlcPrimary',
              fileName: null    // default theme is always loaded
            },
            'easycare-theme': {
                name: 'EASYCARE',
                fileName: 'EASYCARE.css'
            },
            'ally-theme': {
                name: 'ALLY',
                fileName: 'ALLY.css'
            }/*,
            'fordesp-theme': {
                name: 'FORDESP',
                fileName: 'FORD.css'
            }*/
        };

       var _currentTheme = _availableThemes.default;

       service.getCurrentTheme =  function() {
            var providerCode = imSessionVarsService.getCurrentProviderCode();

           // if there is no provider, just use the current theme (could be the default theme)
           if (providerCode) {
                // If we have a provider, use the provider's theme, but fallback to default if it doesn't have one
                _currentTheme = _availableThemes[providerCode.toLowerCase() + "-theme"] || _availableThemes.default;
            }
            return _currentTheme;    // guaranteed to be one of the available themes
        };

        // Function not used at present
        service.clearTheme = function() {
            _currentTheme = _availableThemes.default;
        }

        return service;
    }]);